  import jsPDF from "jspdf";
  import brand_logo from "../../../assets/brand_logo4.png";

  const loadImageAsBase64 = async (url) => {
    try {
      if (!url) return null;

      const res = await fetch(url);
      if (!res.ok) return null;

      const blob = await res.blob();

      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error("Image load failed:", url, error);
      return null;
    }
  };

  const getImageType = (base64 = "") => {
    if (base64.includes("image/jpeg") || base64.includes("image/jpg")) return "JPEG";
    if (base64.includes("image/webp")) return "WEBP";
    return "PNG";
  };

  const generateBulkPDF = async ({
    bookIds = [],
    rooms = [],
    form,
    nights,
    grandTotal,
    paidAmount,
    receivedAdvance = 0,
    remainingPayable = 0,
    discountAmount = 0,
    amountType = null,
    paymentStatus = "",
    roomData = {},
    paidAmounts = {},
    loyaltyDiscountPercent = 0,
    loyaltyDiscountAmount = 0,
    gst = 0,
    
    gstPercent = 0,
    gstAmount = 0,
    headerImg = "",
    footerImg = "",
    showUnitName = false,

    hourlyBook,
    totalHours,
    bookingType,
    ratePerHour,

    overdue_amount = 0,
    overdue_duration = "",
    early_checkin_amount = 0,
    full_book,
    isHistory,
    gstType
  }) => {
    console.log("@@@@@@@@", gst);

    const W = 80;
    const margin = 6;
    const contentW = W - margin * 2;
    let y = 0;

    const LOGO_H = 18;
    const LOGO_W = 52;
    const LOGO_PADDING = 1;
    const HEADER_H = 6;
    const totalHeaderH = LOGO_PADDING + LOGO_H + LOGO_PADDING + HEADER_H;

    // const fmtRs = (v) => `Rs.${Number(v || 0).toLocaleString()}`;
    const fmtRs = (v, decimals = 0) =>
      `Rs.${Number(v || 0).toLocaleString(undefined, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      })}`;

    const totalPayable = Number(grandTotal || 0);
    const paid = Number(paidAmount || 0);
    const discount = Number(discountAmount || 0);
    const advance = Number(receivedAdvance || 0);
    const remaining = Number(remainingPayable || 0);

    const isDiscount = amountType === "discount" || discount > 0;
    const isAdvance = amountType === "advance" || advance > 0 || remaining > 0;

    const isFullPaid = isDiscount
      ? paid + discount >= totalPayable
      : remaining <= 0 && paid >= totalPayable;

    const finalStatus =
      paymentStatus ||
      (isDiscount
        ? "Discount Applied"
        : isFullPaid
          ? "Fully Paid"
          : "Advance Received");

    const loyaltyPercent = Number(loyaltyDiscountPercent || 0);
    const loyaltyAmount = Number(loyaltyDiscountAmount || 0);

    const finalGstPercent = Number(gstPercent || gst || 0).toFixed()
      ;

    const finalGstAmount =
      finalGstPercent > 0
        ? Number(
          gstAmount ||
          totalPayable - totalPayable / (1 + finalGstPercent / 100)
        )
        : 0;

    const HEADER_TOP_GAP = 5;
    const FOOTER_H = 16;

    const extraHourlyHeight =
      (bookingType ? 10 : 0) +
      (totalHours ? 6 : 0) +
      (ratePerHour ? 6 : 0);

    // Count how many payment rows will be drawn
    const paymentRowCount =
      1 + // Payment Mode
      (form?.customer_gst ? 1 : 0) +
      (Number(gstPercent || gst) > 0 ? 1 : 0) +
      (Number(loyaltyDiscountPercent) > 0 ? 1 : 0) +
      (Number(early_checkin_amount) > 0 ? 1 : 0) +
      (Number(overdue_amount) > 0 ? 1 : 0) +
      1 + // Total Payable Amount
      (discountAmount > 0 ? 1 : 0) +
      ((amountType === "advance" || receivedAdvance > 0) && discountAmount <= 0 ? 2 : 0) +
      1; // Payment Status

    const baseHeight =
      HEADER_TOP_GAP + LOGO_H + 13 + 4 +
      5 + 5 + 5 +
      (form?.address ? 5 : 0) +
      7 +
      5 + 5 + 5 + 5 +
      rooms.length * 5 +
      7 +
      5 +
      paymentRowCount * 5 +
      0 +
      extraHourlyHeight +
      (footerImg ? FOOTER_H : -20);                        // bottom padding

    const doc = new jsPDF({ unit: "mm", format: [W, baseHeight - 10], compress: true }); // here i changd to ++ height in the print preview

    const centerText = (text, yPos) => {
      const textW = doc.getTextWidth(text);
      doc.text(text, (W - textW) / 2, yPos);
    };

    const dashedLine = (yPos) => {
      doc.setDrawColor(180);
      doc.setLineDashPattern([1, 1], 0);
      doc.line(margin, yPos, W - margin, yPos);
      doc.setLineDashPattern([], 0);
    };

    const solidLine = (yPos) => {
      doc.setDrawColor(180);
      doc.setLineWidth(0.2);
      doc.line(margin, yPos, W - margin, yPos);
    };

    const row = (label, value, yPos) => {
      doc.setFontSize(8);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(0, 0, 0);
      doc.text(String(label), margin, yPos);

      doc.setTextColor(20);
      const valStr = String(value ?? "—");
      const valW = doc.getTextWidth(valStr);
      doc.text(valStr, W - margin - valW, yPos);
    };

    const rowWrap = (label, value, yPos) => {
      const valStr = String(value ?? "—");
      doc.setFontSize(8);
      doc.setFont("helvetica", "bold");

      const labelW = doc.getTextWidth(label) + 2;
      const availW = contentW - labelW;
      const valW = doc.getTextWidth(valStr);

      if (valW <= availW) {
        doc.setTextColor(0, 0, 0);
        doc.text(label, margin, yPos);

        doc.setTextColor(20);
        doc.text(valStr, W - margin - valW, yPos);
        return yPos + 5;
      }

      doc.setTextColor(0, 0, 0);
      doc.text(label, margin, yPos);
      yPos += 4;

      const lines = doc.splitTextToSize(valStr, contentW);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(7.5);
      doc.setTextColor(20);

      lines.forEach((line) => {
        doc.text(line, margin, yPos);
        yPos += 4;
      });

      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);

      return yPos + 1;
    };

    const sectionTitle = (text, yPos) => {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(6.8);
      doc.setTextColor(0, 0, 0);
      doc.text(text, margin, yPos);
      solidLine(yPos + 1.5);
      return yPos + 5;
    };

    const logoX = (W - LOGO_W) / 2;

    const headerBase64 = await loadImageAsBase64(headerImg);

    if (headerBase64) {
      doc.addImage(headerBase64, getImageType(headerBase64), 0, HEADER_TOP_GAP, W, LOGO_H + 5);
    } else {
      try {
        doc.addImage(brand_logo, "PNG", logoX, HEADER_TOP_GAP, LOGO_W, LOGO_H);
      } catch {
        doc.setFont("helvetica", "bold");
        doc.setFontSize(8);
        doc.setTextColor(0, 0, 0);
        centerText("[Logo]", HEADER_TOP_GAP + LOGO_H / 2);
      }
    }

    if (showUnitName) {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(7);
      doc.setTextColor(80);
      centerText("Unit of Sri Chakra Enterprises", HEADER_TOP_GAP + LOGO_H + 9);
    }

    y = HEADER_TOP_GAP + LOGO_H + 13 + 4;

    y = sectionTitle("GUEST DETAILS", y);
    y = rowWrap("Guest Name", form?.guest_name, y);
    row("Phone", form?.phone, y);
    y += 5;



    y += 2;
    dashedLine(y);
    y += 5;

    y = sectionTitle("STAY DETAILS", y);
    row("Check-In", `${form?.check_in || "—"}${form?.check_in_time ? ` (${form.check_in_time})` : ""}`, y);
    y += 5;
    row("Check-Out", `${form?.check_out || "—"}${form?.check_out_time ? ` (${form.check_out_time})` : ""}`, y);
    y += 5;

    row("Adult", form?.guests || "—", y);
    y += 5;

    // if (form?.child > 0 && form?.child_age?.length) {
    //   row(
    //     "Child Summary",
    //     `${form.child} Child${form.child > 1 ? "ren" : ""} (${form?.child_age
    //       .map((c) => (c.age === 0 ? "0-1Y" : `${c.age}Y`))
    //       .join(", ")})`,
    //     y
    //   );
    //   y += 5;
    // }

    const childAgeList = Array.isArray(form?.child_age)
    ? form.child_age
    : (() => {
        try {
          const parsed = JSON.parse(form?.child_age || "[]");
          return Array.isArray(parsed) ? parsed : [];
        } catch {
          return [];
        }
      })();

  if (Number(form?.child) > 0 && childAgeList.length > 0) {
    row(
      "Child Summary",
      `${form.child} Child${Number(form.child) > 1 ? "ren" : ""} (${childAgeList
        .map((c) => {
          const age = typeof c === "object" ? Number(c.age || 0) : Number(c || 0);
          return age === 0 ? "0-1Y" : `${age}Y`;
        })
        .join(", ")})`,
      y
    );
    y += 5;
  }

    rooms.forEach((roomItem) => {
      const roomLabel = roomItem?.room_name || "Room";
      const roomNum = roomItem?.room_number ? ` (#${roomItem.room_number})` : "";
      // row("Room Details", `${roomLabel}${roomNum}`, y);
      row("Room Details", `${roomLabel}`, y);
      y += 5;
    });

    y += 2;
    dashedLine(y);
    y += 5;

    y = sectionTitle("PAYMENT SUMMARY", y);

    row("Payment Mode", form?.payment_mode || "—", y);
    y += 5;

    // hourlyBook,
    // totalHours,
    // bookingType,
    // ratePerHour,



    if (form?.customer_gst) {
      row("GST Number", form.customer_gst, y);
      y += 5;


    }

    if (loyaltyPercent > 0) {
      row(`Loyalty Discount (${loyaltyPercent}%)`, `-${fmtRs(loyaltyAmount)}`, y);
      y += 5;
    }

    if (Number(early_checkin_amount) > 0) {
      row("Early Check-in Charge", `+${fmtRs(early_checkin_amount)}`, y);
      y += 5;
    }

    //   if (Number(overdue_amount) > 0) {
    // row(`Overdue Charges${overdue_duration ? ` (${overdue_duration})` : ""}`, fmtRs(overdue_amount), y);
    //     y += 5;
    // }

    // row("Total Payable Amount", fmtRs(totalPayable), y);
  if (gstType === "exclusive") {
    row(
      "Total Payable Amount",
      fmtRs(Number(totalPayable) + Number(overdue_amount || 0)),
      y
    );
    y += 4;

    if (finalGstPercent > 0) {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(6);
    doc.setTextColor(0);
    doc.text(`GST (${finalGstPercent}%) Included`, margin, y);

    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    doc.setTextColor(0);
    y += 5;
    }
  }
    if(gstType == 'inclusive'){
    

    row("Total Payable Amount", fmtRs(Number(totalPayable) + Number(overdue_amount || 0)), y);
    y += 5;

    if (finalGstPercent > 0) {
      const half = finalGstAmount / 2;
      row(`CGST (${finalGstPercent / 2}%)`, fmtRs(half), y);
      y += 5;
      row(`SGST (${finalGstPercent / 2}%)`, fmtRs(half), y);
      y += 5;
    }

    }


    if (isDiscount) {
      row("Discount Applied", fmtRs(discount), y);
      y += 5;
    }

    if (!isHistory) {
      row("Received Amount", fmtRs(advance), y);
      y += 5;
    }

    if (isAdvance && !isDiscount) {
      // row("Advance Received", fmtRs(advance || paid), y);
      // y += 5;

      row("Remaining Amount", fmtRs(remaining), y);
      y += 5;
    }

    row("Grand Total", fmtRs(Number(grandTotal) - discount), y);
    y += 5;


    // row("Payment Status", finalStatus, y);
    // y += 7;

    doc.setFillColor(240, 255, 244);
    doc.roundedRect(margin, y, contentW, 9, 1.8, 1.8, "F");

    dashedLine(y);
    y += 4;

    const now = new Date();
    const printed = now
      .toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
      .replace(",", "");

    // doc.setFont("helvetica", "bold");
    // doc.setFontSize(6.5);
    // doc.setTextColor(150);
    // // centerText(`Printed: ${printed}`, y);
    // y += 5;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(7.5);
    doc.setTextColor(0, 0, 0);
    centerText("Thank you for your stay visit again!", y);
    y += 0;

    // if (footerImg) {
    //     const footerBase64 = await loadImageAsBase64(footerImg);
    //     if (footerBase64) {
    //       y += 4;
    //       doc.addImage(footerBase64, getImageType(footerBase64), 0, y, W, FOOTER_H);
    //       y += FOOTER_H + 2;
    //     }
    //   }


    //  print below
    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);

    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";

    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();

      setTimeout(() => {
        document.body.removeChild(iframe);
        URL.revokeObjectURL(pdfUrl);
      }, 1000);
    };

    // const pdfBlob = doc.output("blob");
    // const pdfUrl = URL.createObjectURL(pdfBlob);


    window.open(pdfUrl, "_blank");
    setTimeout(() => URL.revokeObjectURL(pdfUrl), 3000);

  };

  export default generateBulkPDF;